@import '../../../../../constants/spacing.module.less';
@import (reference) '../../../settings-page.module.less';

.custom-packages-table {
  width: 100%;
  border: @settings-page--table--border;
  color: @settings-page--table--body--cell--text-color;
  background-color: @settings-page--table--body--cell--background-color;
  font-size: @settings-page--table--font-size;
  line-height: @settings-page--table--line-height;
}

.header-row {
  font-weight: @settings-page--table--header--cell--font-weight;
  color: @settings-page--table--header--cell--text-color;
  background-color: @settings-page--table--header--cell--background-color;
  border-bottom: @settings-page--table--border;
}

.actions-cell {
  justify-content: flex-end;
}

.image-wrapper {
  align-items: center;
  padding: @space-24;
  gap: @space-8;
}

.menu-toggler {
  height: 32px;
  width: 32px;
  border-radius: 6px;
  color: var(--grey-900);

  &:hover {
    background-color: var(--table--actions-dropdown--hover--background-color);
    color: var(--table--actions-dropdown--hover--text-color);
  }
}

.menu-toggler-contents {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    width: 16px;
  }
}

.action-menu-wrapper {
  .danger {
    color: var(--error--wrapper--text-color--1);
  }
}
